import clsx from "clsx";
import React from "react";

type Props = {
  currentStep: number;
  totalStep?: number;
  className?: string;
  wrapperClassName?: string;
  rounded?: boolean;
  nonSticky?: boolean;
};

export default function ProgressBar({
  currentStep,
  className,
  wrapperClassName,
  rounded,
  nonSticky = false,
  totalStep = 3,
}: Props) {
  const progressWidth = (currentStep / totalStep) * 100;

  return (
    <div
      className={clsx([
        "bg-white py-1",
        { "sticky top-[60px]": !nonSticky },
        wrapperClassName,
      ])}
    >
      <div
        className={clsx([
          " bg-brand-primary-gray-100 bg-opacity-10 relative",
          {
            "rounded-full": rounded,
          },
        ])}
      >
        <div
          className={clsx([
            "h-1 bg-magenta transition-all duration-500 ease-in-out w-full",
            className,
            {
              "rounded-l-full": rounded,
              "rounded-r-full": rounded && currentStep === totalStep,
            },
          ])}
          style={{ width: `${progressWidth}%` }}
        />

        {Array.from({ length: totalStep - 1 }).map((_, index) => (
          <div
            key={index}
            className={clsx(["h-full w-px bg-white absolute top-0"])}
            style={{ left: ((index + 1) / totalStep) * 100 + "%" }}
          ></div>
        ))}
      </div>
    </div>
  );
}
